import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { I18n } from "@aws-amplify/core";
//import { fetchPut } from "../../api/fetch";
import { get, slice, toLower, map, join } from "lodash";

import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Box from "@material-ui/core/Box";
import NativeSelect from "@material-ui/core/NativeSelect";
import OutlinedInput from "@material-ui/core/OutlinedInput";

import CustomButton from "../Common/CustomButton";

import colors from "../../assets/style/colors";

import { updateLanguage } from "../../actions/user";

import { getLov } from "../../utils/lov";

const styles = {
  inputLabel: {
    color: colors.black87,
    fontWeight: "500",
    marginTop: "24px",
    fontSize: "1em",
  },
  centerButton: {
    textAlign: "center",
    marginTop: "20px",
  },
  input: {
    height: "40px",
  },
  select: {
    paddingTop: 0,
    paddingBottom: 0,
    height: "40px",
    fontSize: "0.875em",
  },
};

const Settings = (props) => {
  const [availableLang, setAvailableLang] = useState([]);
  const [language, setLanguage] = useState("");

  useEffect(() => {
    const fetchLanguages = async () => {
      let languages = await getLov(35);
      setAvailableLang(languages);
      setLanguage(props.user.languageId);
    };
    if (availableLang.length === 0) {
      fetchLanguages();
    }
  });

  const handleSubmit = async () => {
    try {
      let profileAttr = [];
      props.user.profile.attributes.forEach((attr) => {
        if (attr.id === 35) {
          profileAttr.push({ id: 35, value: parseInt(language) });
        } else if (attr.value) {
          profileAttr.push({ id: attr.id, value: attr.value });
        }
      });
      // await fetchPut("profiles/" + props.user.profile.id, {
      //   attributes: profileAttr,
      // });
      await props.dispatch(
        updateLanguage(
          parseInt(language) === 4 ? "fr" : "en",
          parseInt(language)
        )
      );
      I18n.setLanguage(parseInt(language) === 4 ? "fr" : "en");
      props.history.push("/myAccount/");
      console.log("Update Successfull");
      setLanguage(parseInt(language));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Grid item xs>
        <form>
          <InputLabel htmlFor="name" className={props.classes.inputLabel}>
            {I18n.get("account_interfaceLanguage")}
          </InputLabel>
          <NativeSelect
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            inputProps={{
              className: props.classes.select,
            }}
            input={
              <OutlinedInput
                fullWidth
                name="language"
                id="language-select"
                className={props.classes.input}
              />
            }
          >
            {map(availableLang, (lang) => (
              <option value={lang.id} key={lang.id}>
                {
                  lang[
                    `name_${toLower(
                      join(slice(get(lang, ["name_en"]), 0, 2), "")
                    )}`
                  ]
                }
              </option>
            ))}
          </NativeSelect>
        </form>
      </Grid>
      <Grid item>
        <Box className={props.classes.centerButton}>
          <CustomButton
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            {I18n.get("account_update")}
          </CustomButton>
        </Box>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  if (state.user) {
    return {
      user: state.user,
    };
  }
};

export default connect(mapStateToProps)(withStyles(styles)(Settings));
